import { IconProps } from "./types";
import React from "react";

export const AlertIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M20.9999 12.001C20.9999 7.03223 16.9687 3.00098 11.9999 3.00098C7.03119 3.00098 2.99994 7.03223 2.99994 12.001C2.99994 16.9697 7.03119 21.001 11.9999 21.001C16.9687 21.001 20.9999 16.9697 20.9999 12.001Z"
      stroke={fill}
      strokeMiterlimit="10"
    />
    <path
      d="M11.7308 7.78468L11.9999 13.5011L12.2685 7.78468C12.2701 7.74814 12.2643 7.71164 12.2514 7.67742C12.2385 7.64319 12.2187 7.61197 12.1933 7.58564C12.1679 7.55932 12.1374 7.53845 12.1036 7.52432C12.0699 7.51018 12.0336 7.50307 11.9971 7.50343V7.50343C11.9609 7.50377 11.9252 7.51139 11.8921 7.52584C11.8589 7.54028 11.829 7.56126 11.8042 7.58751C11.7793 7.61376 11.76 7.64475 11.7474 7.67862C11.7348 7.7125 11.7292 7.74857 11.7308 7.78468V7.78468Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 17.2437C11.8144 17.2437 11.6332 17.1887 11.479 17.0857C11.3248 16.9826 11.2047 16.8362 11.1337 16.6649C11.0628 16.4936 11.0442 16.3051 11.0804 16.1233C11.1165 15.9414 11.2058 15.7744 11.3369 15.6432C11.468 15.5121 11.6351 15.4228 11.817 15.3867C11.9988 15.3505 12.1873 15.3691 12.3586 15.44C12.5299 15.511 12.6763 15.6311 12.7794 15.7853C12.8824 15.9395 12.9373 16.1207 12.9373 16.3062C12.9373 16.5548 12.8386 16.7933 12.6628 16.9691C12.4869 17.1449 12.2485 17.2437 11.9998 17.2437Z"
      fill={fill}
    />
  </svg>
);
